import React, { FC, useState } from "react";
// import { randomColor } from "../../utils"
import PlaylistTrack from "./playlist/PlaylistTrack";
import { connect } from "react-redux";
import AppUICard from "../cards/AppUICard";
import { RootState } from "../../store/reducers";
import { Track } from "../../models/track";

const Charts: FC<{
  list: Track[];
  tags?: string[];
}> = ({ list }) => {
  const filter = [
    "Week",
    "Month",
    "Quarter",
  ];
  const [index, setIndex] = useState(0);

  document.getElementsByTagName("title")[0].innerHTML = "charts";

  return (
    <div className="app-view">
      <div className="app-view-body" id="charts">
        <div className="with-filter">
          <h4 className="app-text">Top this {`${filter[index]}`}</h4>
          <span>
            <i className="material-icons-outlined md-18">filter_list</i>
            <div
              data-uk-dropdown="pos: bottom-right; delay-hide: 100"
              className=" uk-border-rounded uk-width-small"
              id="filter"
            >
              <ul className="uk-nav uk-dropdown-nav">
                {filter.map((f, i) =>
                  <li
                    key={i}
                    onClick={() => setIndex(i)}
                  >
                    {`${f}ly`}
                  </li>
                )}
                {/* <li>Weekly</li>
                <li style={{ marginTop: `8px` }}>Monthly</li>
                <li style={{ marginTop: `8px` }}>Quarterly</li> */}
              </ul>
            </div>
          </span>
        </div>
        <div className="tracks-gid">
          {list &&
            list
              .sort((a, b) => (a.likes.length > b.likes.length ? -1 : 1))
              .map((track) => (
                <PlaylistTrack track={track} tid={track.id} key={track.id} />
              ))}
        </div>
      </div>
      <div className="app-view-extra ls">
        <div className="extras-body">
          <div>
            <div className="artist">
              <div
                className="artist-name"
                style={{ fontSize: "24px", marginBottom: "8px" }}
              >
                Featured
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {list && list.map((a, i) => <AppUICard track={a} key={i} />)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  tags: state.data.tags,
  list: state.data.list,
});

export default connect(mapStateToProps)(Charts);
